"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreatePromptGroupRequest = void 0;
var class_transformer_1 = require("class-transformer");
var class_validator_1 = require("class-validator");
var prompt_group_conditions_1 = require("./prompt-group-conditions");
var abstract_struct_1 = require("../abstract-struct");
var is_not_empty_string_1 = require("../../class-validators/is-not-empty-string");
var case_insensitive_ingest_1 = require("../../class-transformers/case-insensitive-ingest");
var delivery_channels_enum_1 = require("../../enums/delivery-channels.enum");
var slide_prompt_1 = require("./styles/slide/slide-prompt");
var prompt_style_1 = require("../../enums/prompts/prompt-style");
var bell_prompt_1 = require("./styles/bell/bell-prompt");
var native_prompt_1 = require("./styles/native/native-prompt");
var custom_prompt_1 = require("./styles/custom/custom-prompt");
var create_abstract_prompt_request_1 = require("./styles/create-abstract-prompt-request");
var is_not_xss_vulnerability_1 = require("../../class-validators/is-not-xss-vulnerability");
var with_default_value_1 = require("../../class-transformers/with-default-value");
var CreatePromptGroupRequest = (function (_super) {
    __extends(CreatePromptGroupRequest, _super);
    function CreatePromptGroupRequest() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        (0, class_transformer_1.Expose)(),
        (0, is_not_xss_vulnerability_1.IsNotXssVulnerability)(),
        (0, is_not_empty_string_1.IsNotEmptyString)(),
        __metadata("design:type", String)
    ], CreatePromptGroupRequest.prototype, "name", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        (0, class_validator_1.IsEnum)(delivery_channels_enum_1.DeliveryChannel),
        __metadata("design:type", String)
    ], CreatePromptGroupRequest.prototype, "channel", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'is_active' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, class_validator_1.IsBoolean)(),
        __metadata("design:type", Boolean)
    ], CreatePromptGroupRequest.prototype, "isActive", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'is_ab_test' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, class_validator_1.IsBoolean)(),
        __metadata("design:type", Boolean)
    ], CreatePromptGroupRequest.prototype, "isAbTest", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'display_to_pct' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, class_validator_1.IsPositive)(),
        (0, class_validator_1.IsInt)(),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Number)
    ], CreatePromptGroupRequest.prototype, "displayToPct", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        (0, class_validator_1.Min)(0),
        (0, class_validator_1.IsInt)(),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Number)
    ], CreatePromptGroupRequest.prototype, "priority", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        (0, with_default_value_1.WithDefaultValue)(null),
        (0, class_validator_1.ValidateNested)(),
        (0, class_transformer_1.Type)(function () { return prompt_group_conditions_1.PromptGroupConditions; }),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Object)
    ], CreatePromptGroupRequest.prototype, "conditions", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        (0, class_validator_1.ValidateNested)({ each: true }),
        (0, class_transformer_1.Type)(function () { return create_abstract_prompt_request_1.CreateAbstractPromptRequest; }, {
            discriminator: {
                property: 'style',
                subTypes: [
                    { value: slide_prompt_1.CreateSlidePromptRequest, name: prompt_style_1.PromptStyle.SLIDE },
                    { value: bell_prompt_1.CreateBellPromptRequest, name: prompt_style_1.PromptStyle.BELL },
                    { value: native_prompt_1.CreateNativePromptRequest, name: prompt_style_1.PromptStyle.NATIVE },
                    { value: custom_prompt_1.CreateCustomPromptRequest, name: prompt_style_1.PromptStyle.PUBLISHER_CUSTOM },
                ],
            },
            keepDiscriminatorProperty: true,
        }),
        (0, class_validator_1.IsArray)(),
        __metadata("design:type", Array)
    ], CreatePromptGroupRequest.prototype, "prompts", void 0);
    return CreatePromptGroupRequest;
}(abstract_struct_1.AbstractStruct));
exports.CreatePromptGroupRequest = CreatePromptGroupRequest;
//# sourceMappingURL=create-prompt-group-request.js.map